// extracted by mini-css-extract-plugin
export default {"focusBox":"index_focusBox_bfxnO","focusPic":"index_focusPic_z-vdG","focusImg":"index_focusImg_Z8w3Z","focusText":"index_focusText_7QcqR"};